import { render, staticRenderFns } from "./SplitActionButton.vue?vue&type=template&id=31ba50d4&"
import script from "./SplitActionButton.vue?vue&type=script&lang=js&"
export * from "./SplitActionButton.vue?vue&type=script&lang=js&"
import style0 from "./SplitActionButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports